__turbopack_context__.v({
  "container": "f-Tuta_container",
  "equation": "f-Tuta_equation",
  "figure": "f-Tuta_figure",
  "fraction": "f-Tuta_fraction",
  "fractionDenominator": "f-Tuta_fractionDenominator",
  "fractionNumerator": "f-Tuta_fractionNumerator",
  "fractionRule": "f-Tuta_fractionRule",
  "term": "f-Tuta_term",
  "times": "f-Tuta_times",
  "value": "f-Tuta_value",
});
